import { apiClient } from './api-client';
import type { AdminProfile } from './session';

/** Always resolves the same way whether or not the address exists — the API will not say. */
export function requestPasswordReset(email: string) {
  return apiClient.post<{ sent: true }>('/auth/forgot-password', { email }, { anonymous: true });
}

export function resetPassword(token: string, password: string) {
  return apiClient.post<{ reset: true }>(
    '/auth/reset-password',
    { token, password },
    { anonymous: true },
  );
}

/** Revokes every session on the server, this one included. */
export function changePassword(currentPassword: string, newPassword: string) {
  return apiClient.post<{ changed: true }>('/auth/change-password', {
    currentPassword,
    newPassword,
  });
}

export function updateOwnProfile(firstName: string, lastName: string) {
  return apiClient.patch<AdminProfile>('/auth/me', { firstName, lastName });
}
